"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagGI = function FlagGI(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.06,7.06,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.06,7.06,0,0,1-193,139.3V54.55H216.6V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M89.48-23.13V-37.25H75.36V-72.57h7.06V-86.69H40.05v14.12h7.06v35.32H25.93V-86.69h7v-14.12H-9.39v14.12h7.07v49.44H-23.51V-72.57h7.06V-86.69H-58.82v14.12h7.06v35.32H-65.88v14.12h7.06v56.5h-7.06V47.49H89.48V33.37H82.42v-56.5Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M25.93,40.43H-2.32V12.18a14.13,14.13,0,1,1,28.25,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.8-58.44a7.06,7.06,0,0,0-7.06,7.06v21.19H18.86V-51.38a7.06,7.06,0,0,0-7.06-7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M61.23-51.38a7.06,7.06,0,0,0-7.06,7.06v14.13H68.3V-44.32a7.06,7.06,0,0,0-7.07-7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-37.64-51.38a7.06,7.06,0,0,0-7.06,7.06v14.13h14.13V-44.32a7.06,7.06,0,0,0-7.07-7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M68.3,40.43H40.05V19.24a14.13,14.13,0,0,1,28.25,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-16.45,40.43H-44.7V19.24A14.12,14.12,0,0,1-30.57,5.12,14.12,14.12,0,0,1-16.45,19.24Zm0,0",
    transform: "translate(194 123)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M31.22,65.14a3.51,3.51,0,0,0-1.57-2.93L15.33,52.66v-3L27.5,43.59a3.53,3.53,0,0,0-3.16-6.32L11.8,43.54-.75,37.27a3.52,3.52,0,0,0-4.73,1.58A3.52,3.52,0,0,0-3.9,43.59L8.27,49.67v3L-6,62.21a3.51,3.51,0,0,0-1.57,2.93A3.53,3.53,0,0,0-6,68.08L8.27,77.63v29.89H-5.86v5.41a3.53,3.53,0,0,0,3.54,3.53A3.54,3.54,0,0,0,.8,114.58H8.27v7.06H.73a3.53,3.53,0,0,0-3-1.76,3.53,3.53,0,0,0-3.54,3.53v5.3H8.27v3.53a3.53,3.53,0,0,0,7.06,0V77.63l14.32-9.54a3.56,3.56,0,0,0,1.57-3ZM11.8,71.49,2.27,65.14,11.8,58.8l9.52,6.34Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagGI;
exports["default"] = _default;